import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=authed
  const [blocked, setBlocked] = useState(false); // IP not on firm allowlist
  const [blockedIp, setBlockedIp] = useState("");
  const [dark, setDark] = useState(() => localStorage.getItem("mh-theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("mh-theme", dark ? "dark" : "light");
  }, [dark]);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setBlocked(false);
      setUser(data);
    } catch (e) {
      if (e.response?.status === 403 && e.response?.data?.restricted) {
        setBlockedIp(e.response.data.ip || "");
        setBlocked(true);
      }
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("server logout failed; clearing local session", e); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, blocked, blockedIp, logout, dark, setDark, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
